export default "__VITE_ASSET__x11vxoE6__"